import { render, staticRenderFns } from "./LazyIcon.vue?vue&type=template&id=fea01c1a"
import script from "./LazyIcon.vue?vue&type=script&lang=js"
export * from "./LazyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports